import { Row, Form, Modal, Col, Radio, Select, notification } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { GenderOptions, getGenderName } from '../../models/user'
import {
  getSourceTypeName,
  RegistrationCategory,
  SourceTypeCategories,
} from '../../models/registration'
import {
  getDepartmentDoctorList,
  getDoctorDepartmentList,
  getDoctorList,
} from '../sales/DoctorAccont/doctorAuditSlice'
import { Department } from '../../models/department'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  getDoctorsInDepartment,
  getFullDeparmentList,
} from '../completion/completionSlice'
import styles from './Registration.module.css'
import { selectInsuranceArray, selectUserId } from '../../app/applicationSlice'
import { MedicelListValue } from '../../models/setting'
import { selectDoctors } from './list/registrationSlice'
import { Checks, Settinglable } from '../../models/personalSetting'
import _ from 'lodash'
import { getAllPersonalPreferences, getUserProfileList, saveSetting } from '../personalManagement/personalDetail/personalDetailSlice'
import { getPatientOptionsAsync } from '../A-toothModule/toothHome/toothHomeSlice'

export const PreferencesSettingModal = (props: {
  visible: boolean
  onOk: () => void
  onCancel: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  // const allPersonalPreferences = JSON.parse(localStorage?.getItem('allPersonalPreferences') || '{}')

  // const checkData = allPersonalPreferences?.records || []

  const insuranceArray = useSelector(selectInsuranceArray)

  const [departments, setDepartments] = useState<Department[]>([])

  const [departmentIds, setDepartmentId] = useState<any>()

  const [doctorList, setDoctorList] = useState<any>([]) //医生数据

  const doctors = useSelector(selectDoctors)

  const userId = useSelector(selectUserId)

  const [departmentDoctorRadio, setDepartmentDoctorRadio] = useState<any>(1)

  const [form] = Form.useForm()

  const { Option } = Select

  const [classificationList, setClassificationList] = useState<any>() //自定义患者来源数据
  
  const [buttonLoading, setButtonLoading] = useState(false) //确认按钮loading状态

  const localData: any = JSON.parse(
    localStorage.getItem('preferencesSettingData') || '{}'
  )

  useEffect(() => {
    if (props?.visible) {
      if (departmentIds || localData?.departmentId) {
        // dispatch(getDoctorsInDepartment(storedepartmentId))
        dispatch(
          getDoctorDepartmentList(departmentIds || localData?.departmentId)
        )
          .then(unwrapResult)
          .then((doctors: any) => {
            setDoctorList(doctors?.records)
          })
      } else {
        dispatch(getDoctorDepartmentList(''))
          .then(unwrapResult)
          .then((doctors: any) => {
            setDoctorList(doctors?.records)
          })
      }

      dispatch(getDepartmentDoctorList())
        .then(unwrapResult)
        .then((departments: any) => {
          setDepartments(departments?.records)
        })
    } else {
      // dispatch(getDoctorsInDepartment(''))
      localStorage.setItem(
        'preferencesSettingData',
        JSON.stringify({
          ...localData,
          sex: localData?.sex ? Number(localData?.sex) : 0,
          // source: localData?.source ? Number(localData?.source) : 0,
          patientSource: localData?.patientSource || getSourceTypeName(localData?.source),
          atDoctor: localData?.atDoctor?.toString()
            ? Number(localData?.atDoctor)
            : 1,
        })
      )
    }
  }, [props?.visible, departmentIds, localData?.departmentId])

  const getPersonalSettingDetail = () => {
    let sourceList: any[] = []
    // 获取患者来源
    dispatch(getPatientOptionsAsync({ types: '0,1,2' }))
      .then(unwrapResult)
      .then((res: any) => {
        const findItems = (type: string) => {
          return res ? res?.find((t: any) => t.type == type)?.items?.map((v: any) => {
            return {
              name: v.context,
              value: v.sortNo,
            }
          }) : []
        }
        setClassificationList({
          sourceList: findItems('1'),
        })
        sourceList = findItems('1')
      })
    // 当localStorage中的patientSource为空或空字符串时，默认选择下拉菜单中的第一个选项
    const defaultPatientSource = (localData?.patientSource && localData?.patientSource.trim() !== '')
      ? localData?.patientSource : localData?.source?.toString() ? getSourceTypeName(localData?.source)
        : (sourceList?.length > 0 ? sourceList[0].name : getSourceTypeName(localData?.source));

    // 获取挂号偏好设置 1000 1001 1002 1003
    dispatch(getAllPersonalPreferences({ userId: userId }))
      .then(unwrapResult)
      .then((res: any) => {
        const checkData = res?.records || []
        const GHLB = checkData?.find((item: any) => item?.code == Checks.GHLB)?.codeName //挂号类别
        const HZXB = checkData?.find((item: any) => item?.code == Checks.HZXB)?.codeName //患者性别
        const HZLY = checkData?.find((item: any) => item?.code == Checks.HZLY)?.codeName //患者来源
        const KSYS = checkData?.find((item: any) => item?.code == Checks.KSYS)?.codeName //科室医生

        const atDoctor = KSYS?.toString() && Number(KSYS.split('#')[0])
        const departmentId = KSYS?.toString() && Number(KSYS.split('#')[1])
        const doctorId = KSYS?.toString() && Number(KSYS.split('#')[2])
        setDepartmentDoctorRadio(
          atDoctor ? atDoctor : localData?.atDoctor?.toString() ? Number(localData?.atDoctor) : 1
        )

        form.setFieldsValue({
          [Checks.GHLB]: GHLB?.toString() ? GHLB : localData?.insuranceStatus
            ? localData?.insuranceStatus
            : 'ZIFEI',
          [Checks.HZXB]: HZXB?.toString() ? Number(HZXB) : localData?.sex ? Number(localData?.sex) : 0,
          [Checks.HZLY]: HZLY ? HZLY : defaultPatientSource,
          [Checks.KSYS]: atDoctor?.toString() ? Number(atDoctor) : localData?.atDoctor?.toString()
            ? Number(localData?.atDoctor)
            : 1,
          departmentId: departmentId ? departmentId?.toString() : localData?.departmentId
            ? localData?.departmentId
            : undefined,
          doctorId: doctorId ? doctorId?.toString() : localData?.doctorId ? localData?.doctorId : undefined,
        })
      })
  }

  useEffect(() => {
    if (props?.visible) {
      getPersonalSettingDetail()
    }
  }, [props?.visible])

  return (
    <>
      <Modal
        title={`设置您的偏好`}
        width='500px'
        okText='确定'
        cancelText='取消'
        visible={props.visible}
        confirmLoading={buttonLoading}
        onOk={(e) => {
          form
            .validateFields()
            .then((values) => {
              // localStorage.setItem(
              //   'preferencesSettingData',
              //   JSON.stringify({ ...values })
              // )
              const params: any = {
                [Checks.GHLB]: values[Checks.GHLB],
                [Checks.HZXB]: values[Checks.HZXB],
                [Checks.HZLY]: values[Checks.HZLY],
                [Checks.KSYS]: values[Checks.KSYS] == 2 ? values[Checks.KSYS] + '#' + values?.departmentId + '#' + values?.doctorId : values[Checks.KSYS],
              }
              // 正则匹配 1000–1010 之间的数字（含0）
              const pattern = /^(100[0-9]|1010)$/
              const f = values && _.chain(values)
                .pickBy((_, k) => pattern.test(k))
                .mapValues(
                  (v, k) =>
                  ({
                    code: k,
                    codeName: params[k],
                    userId: userId,
                  } as Settinglable)
                )
                .values()
                .value()
              setButtonLoading(true)
              dispatch(saveSetting(f))
                .then(unwrapResult)
                .then(() => {
                  form.resetFields()
                  props.onOk()
                  notification.success({
                    message: '保存成功，将在下次进入系统时生效',
                  })
                })
                .finally(() => {
                  setButtonLoading(false)
                })
            })
            .catch(() => {
              // Do nothing.
            })
          // form.resetFields()
        }}
        onCancel={() => {
          form.resetFields()
          props.onCancel()
        }}
      >
        <Form
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
          form={form}
        >
          <Row
            style={{ marginBottom: 10, width: '100%' }}
            align='middle'
            justify='space-between'
          >
            <Col span={24}>
              <div className={styles.title}>挂号类别 - 默认设置为：</div>
              <Col span={24} className={styles.main}>
                <Form.Item
                  label=''
                  name={Checks.GHLB}
                  noStyle
                >
                  <Radio.Group>
                    <Radio
                      value={'ZIFEI'}
                      key={RegistrationCategory.SelfPay}
                      onClick={() => {
                        return
                      }}
                    >
                      自费
                    </Radio>
                    {insuranceArray.length > 0 &&
                      insuranceArray.map((v: any) => (
                        <Radio key={JSON.stringify(v)} value={v.insuranceCode}>
                          {v.insuranceName}
                        </Radio>
                      ))}
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Col>
            <Col span={24}>
              <div className={styles.title}>自费患者性别 - 默认为：</div>
              <Col span={24} className={styles.main}>
                <Form.Item label='' name={Checks.HZXB} noStyle>
                  <Radio.Group>
                    {GenderOptions?.map((g) => (
                      <Radio key={g} value={g}>
                        {getGenderName(g)}
                      </Radio>
                    ))}
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Col>
            <Col span={24}>
              <div className={styles.title}>患者来源 - 默认为：</div>
              <Col span={24} className={styles.main}>
                <Form.Item label='' name={Checks.HZLY} noStyle>
                  <Select
                    placeholder='患者来源'
                    allowClear
                    style={{ width: '240px' }}
                  >
                    {classificationList?.sourceList.map((v: any) => {
                      return (
                        <Select.Option key={v.name} value={v.name}>
                          {v.name}
                        </Select.Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Col>
            <Col span={24}>
              <div className={styles.title}>科室医生-选择一个默认项</div>
              <Col span={24} className={styles.main}>
                <Form.Item label='' name={Checks.KSYS} noStyle>
                  <Radio.Group
                    onChange={(v: any) => {
                      setDepartmentDoctorRadio(v?.target?.value)
                    }}
                  >
                    <Radio value={0} key={0}>
                      默认空
                    </Radio>
                    <Radio key={1} value={1}>
                      默认选中上一次挂号医生
                    </Radio>
                    <Radio value={3} key={3} >
                      当前账号医生
                    </Radio>
                    <Radio value={2} key={2} style={{ marginTop: '10px' }}>
                      选中特定医生
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {departmentDoctorRadio == 2 && (
                <Row>
                  <Col
                    span={8}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Form.Item label='' name='departmentId' noStyle>
                      <Select
                        placeholder='科室'
                        style={{ width: '8rem' }}
                        allowClear
                        onChange={(v) => {
                          setDepartmentId(v)
                          form.setFieldsValue({
                            doctorId: '',
                          })
                          form.submit()
                        }}
                        showSearch
                      >
                        {departments?.map((d) => (
                          <Select.Option key={d.id} value={d.id?.toString()}>
                            {d.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label='' name='doctorId' noStyle>
                      <Select
                        placeholder='医生'
                        style={{ width: '8rem' }}
                        allowClear
                        onChange={() => {
                          form.submit()
                        }}
                        showSearch
                      >
                        {doctorList?.map((d: any) => (
                          <Select.Option key={d.id} value={d.id?.toString()}>
                            {d.realname}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}
